"use client";

import LoginForm from "@/app/_components/Auth/LoginForm";
import LoginIntro from "@/app/_components/Auth/LoginIntro";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

export default function LoginScreen() {
  const t = useTranslations("auth");

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: { xs: 2, sm: 4, md: 8 },
        py: { xs: 6, md: 10 },
        background:
          "radial-gradient(circle at 10% 10%, rgba(34,197,94,0.14), transparent 45%), radial-gradient(circle at 90% 15%, rgba(59,130,246,0.18), transparent 40%), linear-gradient(180deg, #ffffff 0%, #f3f4ff 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: -140,
          left: -120,
          width: 320,
          height: 320,
          borderRadius: "50%",
          background: "radial-gradient(#c7f9cc 0%, rgba(199,249,204,0) 70%)",
          opacity: 0.55,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: -180,
          right: -140,
          width: 380,
          height: 380,
          borderRadius: "50%",
          background: "radial-gradient(#bfdbfe 0%, rgba(191,219,254,0) 70%)",
          opacity: 0.5,
        }}
      />

      <Box
        sx={{ width: "100%", maxWidth: 1200, position: "relative", zIndex: 1 }}
      >
        <Stack
          direction={{ xs: "column", lg: "row" }}
          spacing={{ xs: 4, lg: 8 }}
          alignItems="stretch"
        >
          <LoginIntro />

          <Box sx={{ width: "100%", maxWidth: 480 }}>
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: "0 24px 48px rgba(15,23,42,0.12)",
                border: "1px solid rgba(148,163,184,0.24)",
              }}
            >
              <CardContent sx={{ p: { xs: 3, sm: 5 } }}>
                <LoginForm />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 2 }}
                >
                  {t("loginIntroFootnote")}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}
